export enum ReturnFormat {
    json = 'json',
    formData = 'formData',
}
